// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gu2O","toggleWrap":"styles_toggleWrap__2RVS_","content":"styles_content__MFs01","selectAreaCode":"styles_selectAreaCode__1cZxn"};